export const envConstants = {
  get ENV() {
    return process.env.ENV;
  },
  get APP_HTTP_PROXY() {
    return process.env.APP_HTTP_PROXY;
  },
  get EPOCH_HOST() {
    return process.env.NEXT_EPOCH_HOST;
  },
  get DEV_MODE() {
    return process.env.DEV_MODE;
  },
  get DISH_POINTER_BASE_URL() {
    return process.env.DISH_POINTER_BASE_URL;
  },
  get EPOCH_ACCESS_TOKEN() {
    return process.env.EPOCH_ACCESS_TOKEN;
  },
  get SB_TIMEOUT_MS() {
    return parseInt(process.env.SB_TIMEOUT || "3000");
  },
  get AEM_TIMEOUT_MS() {
    return parseInt(process.env.AEM_TIMEOUT || "30000");
  },
  get UF_PLIMIT() {
    return parseInt(process.env.UF_PLIMIT || "5");
  },
  get TG_CACHE_INT() {
    return process.env.TG_CACHE_INT;
  },
  get AEM_HOST() {
    return process.env.UF_AEM_CMS_HOST;
  },
  get PCP_SB_ACCESS_TOKEN() {
    return process.env.PCP_SB_ACCESS_TOKEN;
  },
  get USE_ONE_TRUST() {
    return process.env.USE_ONE_TRUST;
  },
  get ONE_TRUST_SCRIPT() {
    return process.env.ONE_TRUST_SCRIPT;
  },
  get ONE_TRUST_DATA_SCRIPT() {
    return process.env.ONE_TRUST_DATA_SCRIPT;
  },
  get EVOLV_ENV() {
    return process.env.EVOLV_ENV;
  },
  get EVOLV_ENABLE_SSR() {
    return process.env.USE_EVOLV_SSR;
  },
  get EVOLV_ENABLE() {
    return process.env.USE_EVOLV;
  },
  get EVOLV_TIMEOUT() {
    return parseInt(process.env.EVOLV_TIMEOUT || "1000");
  },
  get EVOLV_UID() {
    return process.env.EVOLV_UID || "upperfunnel";
  },
  get K8S_ENV_PREFIX() {
    return process.env.K8S_ENV_PREFIX;
  },
  get PLATFORM() {
    return process.env.PLATFORM;
  },
  get USE_STORYBLOK() {
    return process.env.USE_STORYBLOK;
  },
  get SB_PREVIEW_ALLOWED() {
    return process.env.SB_PREVIEW_ALLOWED;
  },
  get SB_DIR_FOLDER() {
    return process.env.SB_DIR_FOLDER;
  },
  get SB_REFERENCE_COMPONENT() {
    return process.env.SB_REFERENCE_COMPONENT;
  },
  get SB_ACCESS_TOKEN() {
    return process.env.SB_ACCESS_TOKEN;
  },
  get UF_CACHE_INT() {
    return parseFloat(process.env.UF_CACHE_INT || "5");
  },
  get HTTP_PROXY() {
    return process.env.HTTP_PROXY;
  },
  get NEXT_ENV() {
    return process.env.NEXT_ENV;
  },
  get SOLR_ENV() {
    return process.env.SOLR_ENV;
  },
  get DTVI_EPOCH_CONTRACT_INDICATOR() {
    return process.env.DTVI_EPOCH_CONTRACT_INDICATOR;
  },
  get DTVS_EPOCH_CONTRACT_INDICATOR() {
    return process.env.DTVS_EPOCH_CONTRACT_INDICATOR;
  },
  get TARGET_ROLE() {
    return process.env.TARGET_ROLE;
  },
  get APP_NAME() {
    return process.env.APP_NAME;
  },
  get NODE_ENV() {
    return process.env.NODE_ENV;
  },
  get PORT() {
    return process.env.PORT;
  },
  get APP_DEV_PROXY() {
    return process.env.APP_DEV_PROXY;
  },
  get NEXT_PUBLIC_LINKED_DTV_ACCT_NUM() {
    return process.env.NEXT_PUBLIC_LINKED_DTV_ACCT_NUM;
  },
  get NEXT_PUBLIC_LINKED_DTVN_ACCT_NUM() {
    return process.env.NEXT_PUBLIC_LINKED_DTVN_ACCT_NUM;
  },
  get NEXT_PUBLIC_UUID() {
    return process.env.NEXT_PUBLIC_UUID;
  },
  get NEXT_PUBLIC_LOGGED_IN_ID() {
    return process.env.NEXT_PUBLIC_LOGGED_IN_ID;
  },
  get NEXT_PUBLIC_SESSION_ID() {
    return process.env.NEXT_PUBLIC_SESSION_ID;
  },
  get NEXT_PUBLIC_AUTHORIZATION() {
    return process.env.NEXT_PUBLIC_AUTHORIZATION;
  },
  get YOTPO_APP_KEY(){
    return process.env.YOTPO_APP_KEY;
  },
  get SEARCH_API_KEY() {
    return process.env.SEARCH_API_KEY;
  },
  get SERVICE_ABILITY_AUTH() {
    return process.env.SERVICE_ABILITY_AUTH;
  },
  get VIDEO_SERVICE_AUTH() {
    return process.env.VIDEO_SERVICE_AUTH;
  },

  get DISABLE_PROXY() {
    return process.env.DISABLE_PROXY;
  },
  get AEM_CMS_HOST() {
    return process.env.AEM_CMS_HOST;
  },
  get UF_AEM_CMS_HOST() {
    return process.env.UF_AEM_CMS_HOST;
  },
  get NEXT_EPOCH_HOST() {
    return process.env.NEXT_EPOCH_HOST;
  },
  get SB_TIMEOUT() {
    return process.env.SB_TIMEOUT
  },
  get AEM_TIMEOUT() {
    return process.env.AEM_TIMEOUT
  },
  get BUILD_VERSION() {
    return process.env.BUILD_VERSION;
  },
  get UF_API_CACHE_INT() {
    if(process.env.ENV === "prod"){
      return parseFloat(process.env.UF_API_CACHE_INT || "10");
    }
    return parseFloat(process.env.UF_API_CACHE_INT || "10");
  },
  get STYLE_OVERWRITE_API_URL() {
    if(process.env.ENV === "prod"){
      return process.env.STYLE_OVERWRITE_API_URL || "https://www.directv.com/assets/content/43gso8pg9m/original/style-overwrite";
    }
    return process.env.STYLE_OVERWRITE_API_URL_TEST || "https://www.directv.com/assets/content/kydz69h3md/original/style-overwrite-test";
  },
  get STYLE_OVERWRITE_TIMEOUT_MS() {
    return parseInt(process.env.STYLE_OVERWRITE_TIMEOUT_MS || "10000");
  },
  get STYLE_OVERWRITE_CACHE_INT() {
    return parseInt(process.env.STYLE_OVERWRITE_CACHE_INT || "15"); // minutes
  },

  get COMPONENT_OVERWRITE_API_URL() {
    if(process.env.ENV === "prod"){
      return process.env.COMPONENT_OVERWRITE_API_URL || "https://www.directv.com/assets/content/hddytjvubt/original/component-overwrite";
    }
    return process.env.COMPONENT_OVERWRITE_API_URL_TEST || "https://www.directv.com/assets/content/zsbgzjfude/original/component-overwrite-test";
  },
  get COMPONENT_OVERWRITE_TIMEOUT_MS() {
    return parseInt(process.env.COMPONENT_OVERWRITE_TIMEOUT_MS || "10000");
  },
  get COMPONENT_OVERWRITE_CACHE_INT() {
    return parseInt(process.env.COMPONENT_OVERWRITE_CACHE_INT || "15"); // minutes
  },

  // WAT-12180: v3's own overwrite feeds. Same prod/non-prod split as the pair
  // above, but NO hardcoded asset fallback — the assets do not exist yet, and
  // an empty URL is what makes the feed inert (the fetcher's `if (!baseUrl)`
  // guard returns null without a request). Point these at real assets in
  // gitops when they are created; nothing in code needs to change.
  //
  // Timeout and cache interval are deliberately shared with the v2 feeds
  // rather than duplicated — same asset host, same cadence.
  get V3_COMPONENT_OVERWRITE_API_URL() {
    if (process.env.ENV === "prod") {
      return process.env.V3_COMPONENT_OVERWRITE_API_URL || "";
    }
    return process.env.V3_COMPONENT_OVERWRITE_API_URL_TEST || "";
  },
  get V3_STYLE_OVERWRITE_API_URL() {
    if (process.env.ENV === "prod") {
      return process.env.V3_STYLE_OVERWRITE_API_URL || "";
    }
    return process.env.V3_STYLE_OVERWRITE_API_URL_TEST || "";
  },

  // WAT-11409: page-by-page App Router + Redis rollout allowlist. A single var;
  // the per-env URL (DAM asset) is supplied by gitops (ConfigMap). When unset the
  // config service returns null → rollout stays off (safe default).
  get PAGE_ROLLOUT_CONFIG_URL() {
    return process.env.PAGE_ROLLOUT_CONFIG_URL || "";
  },
  get PAGE_ROLLOUT_CONFIG_TIMEOUT_MS() {
    // Guarded parse: a malformed ConfigMap value ("10s", whitespace, 0, negative)
    // must NOT yield NaN/0 — timeout() is setTimeout-based, so NaN would abort the
    // fetch on the next tick and freeze the rollout at boot state permanently.
    const val = parseInt(process.env.PAGE_ROLLOUT_CONFIG_TIMEOUT_MS || "10000", 10);
    return Number.isNaN(val) || val <= 0 ? 10000 : val;
  },

  // WAT-11459: remote analytics push-defer toggle. ONE JSON asset shared by
  // every tier; the per-env value is keyed by K8S_ENV_PREFIX. Hardcoded default
  // so no ConfigMap / gitops entry is required to ship.
  //
  // NOTE the difference from its two neighbours, since neither is the pattern
  // being followed here:
  // - COMPONENT_OVERWRITE_API_URL splits prod vs non-prod into two DIFFERENT
  //   assets. This one does not: envs are separated by key INSIDE one asset, so
  //   a lower-env edit does touch the same file prod reads. Failure is
  //   safe-off (bad JSON -> null -> last-known-good), but there is no schema
  //   validation or CI on that artifact — treat edits as production edits.
  // - PAGE_ROLLOUT_CONFIG_URL defaults to "" and REQUIRES a gitops value. This
  //   one ships with a working default instead, because it must be flippable
  //   without a redeploy on day one.
  //
  // `??` not `||` on purpose: an EMPTY STRING is the code-level off switch (no
  // URL → the fetch service returns null → the store keeps its "off" default).
  // `||` would swallow that and fall back to the live asset, making the switch
  // a no-op.
  //
  // ⚠️ ANALYTICS_FLAGS_URL is NOT a key in k8s/cfgmap*.yml or
  // config/env-config.json today, so that off switch is not reachable without
  // first adding it (+ a redeploy). Left unwired on purpose: adding
  // `ANALYTICS_FLAGS_URL: "${ANALYTICS_FLAGS_URL}"` to the templates without
  // also defining the gitops variable renders an empty string, which would
  // silently disable the feature in every tier. The remote asset is the
  // intended kill switch; this is the break-glass path.
  get ANALYTICS_FLAGS_URL() {
    return (
      process.env.ANALYTICS_FLAGS_URL ??
      "https://www.directv.com/assets/content/7qlsovvadf/original/uf-config.json"
    );
  },
  get ANALYTICS_FLAGS_TIMEOUT_MS() {
    // Guarded parse (see PAGE_ROLLOUT_CONFIG_TIMEOUT_MS): NaN/0 would abort the
    // fetch on the next tick and freeze the toggle at its boot value forever.
    const val = parseInt(process.env.ANALYTICS_FLAGS_TIMEOUT_MS || "3000", 10);
    return Number.isNaN(val) || val <= 0 ? 3000 : val;
  },

  // WAT-11409: GLOBAL App Router flag — the App Router analog of DATA_SOURCE=redis
  // (IS_REDIS_DATA_SOURCE). When true, ALL pages fall through to the App Router,
  // independent of the per-page appRouter allowlist. Set via ConfigMap per env.
  // NOTE: backed by the `ROUTER_VERSION` env var (=== "v2"), NOT `IS_APP_ROUTER_GLOBAL`.
  get IS_APP_ROUTER_GLOBAL() {
    return process.env.ROUTER_VERSION?.trim()?.toLowerCase() === "v2";
  },
  get DTVS_EPOCH_SERVER_DATE() {
    return process.env.DTVS_EPOCH_SERVER_DATE;
  },
  get CACHE_KEY_PREFIX() {
    return process.env.CACHE_KEY_PREFIX;
  },
  get IS_DEV_MODE() {
    return process.env.DEV_MODE?.trim()?.toUpperCase?.() === "TRUE";
  },
  get IS_DEV_MINIMAL() {
    // Hard-block in production even if DEV_MINIMAL=true somehow leaks into a prod
    // ConfigMap — the flag skips secrets, cache, and installs a 404 catchall.
    if (process.env.NODE_ENV === "production") {
      return false;
    }
    return process.env.DEV_MINIMAL?.trim()?.toUpperCase?.() === "TRUE";
  },
  get IS_LOCAL() {
    return process.env.LOCAL?.trim()?.toUpperCase?.() === "TRUE";
  },
  get CACHE_MAX_ENTRIES() {
    const val = parseInt(process.env.CACHE_MAX_ENTRIES || "5000", 10);
    return Number.isNaN(val) || val < 1 ? 5000 : val;
  },
  get CACHE_MAX_BYTES() {
    // Byte ceiling for the in-memory fallback LRU. Count-only eviction can OOM
    // the pod heap when values are MB-scale (satellite/channel/page payloads);
    // this bounds total bytes too. Size against the pod memory limit /
    // --max-old-space-size. Default 256MB.
    const val = parseInt(process.env.CACHE_MAX_BYTES || "", 10);
    return Number.isNaN(val) || val < 1 ? 256 * 1024 * 1024 : val;
  },
  /** Server log verbosity: error | warn | info | debug. Defaults to info.
   * Per-request verbose logs are emitted at debug level and therefore
   * skipped (no JSON.stringify cost) unless UF_LOG_LEVEL=debug is set. */
  get LOG_LEVEL() {
    return (process.env.UF_LOG_LEVEL || "info").trim().toLowerCase();
  },
  get CACHE_HOST() {
    return process.env.CACHE_HOST;
  },
  get CACHE_PORT() {
    return parseInt(process.env.CACHE_PORT);
  },
  get CACHE_TLS() {
    // Enable encryption-in-transit to ElastiCache. When true, ioredis connects
    // with tls:{} (standard TLS; SNI = the node endpoint). OFF by default so the
    // current plaintext behavior is unchanged until ops opts in at cutover.
    return process.env.CACHE_TLS?.trim()?.toLowerCase() === "true";
  },
  get CACHE_PASSWORD() {
    // Optional Redis AUTH token / RBAC-user password. Sourced from the gitops
    // PreSync-created Secret in deployed envs (mirrors CHANNELS_SERVICE_AUTH_TOKEN).
    // Unset = no AUTH sent (current behavior).
    return process.env.CACHE_PASSWORD;
  },
  get CACHE_REQUIRE_PREFIX() {
    // When true, initRedisClient THROWS if CACHE_KEY_PREFIX is empty while the
    // Redis cluster CLIENT initializes — i.e. on every non-dev boot REGARDLESS
    // of DATA_SOURCE (deliberate: phase-1 dual-writes reach the possibly-shared
    // cluster just the same, so an unprefixed phase-1 rollout collides with /
    // can clear another tenant exactly like a redis-primary one). Set this on a
    // SHARED ElastiCache cluster. Default false (log-only), since a dedicated
    // per-env cluster needs no prefix and must not fail to boot.
    return process.env.CACHE_REQUIRE_PREFIX?.trim()?.toLowerCase() === "true";
  },
  get CACHE_EXIT_ON_UNHEALTHY_BOOT() {
    // Legacy behavior: process.exit(1) when the boot cache-health gate fails after
    // retries. Default false — do NOT crash the pod on a cold/empty/unreachable
    // Redis at cutover (that causes a correlated CrashLoopBackOff across the
    // fleet). Instead come up UNREADY: /utils/healthcheck returns 500 so the k8s
    // readiness probe holds traffic while the background refresh runner repopulates
    // and flips the health flag. Set true to restore fail-fast exit.
    return process.env.CACHE_EXIT_ON_UNHEALTHY_BOOT?.trim()?.toLowerCase() === "true";
  },
  get API_AUTH_KEY() {
    return process.env.CACHE_API_AUTH_KEY || process.env.EPOCH_ACCESS_TOKEN;
  },
  get IS_REDIS_DATA_SOURCE() {
    return process.env.DATA_SOURCE?.toLowerCase() === "redis";
  },
  get SHADOW_READ_SAMPLE_RATE() {
    const val = parseInt(process.env.SHADOW_READ_SAMPLE_RATE ?? "", 10);
    if (Number.isNaN(val)) {
      return 10;
    }
    return Math.max(0, Math.min(100, val));
  },
  // Shop epoch proxy path — used by the digital (directvOnline) offer calls.
  get EPOCH_OFFERS_PATH() {
    return process.env.EPOCH_OFFERS_PATH || '/shop/api/getOffers';
  },
  // msapi epoch (origin) path — used by the directIntegrationPartner offer call,
  // kept separate from the shop epoch proxy. Host defaults to the shared Epoch
  // host; both are env-overridable.
  get EPOCH_MSAPI_HOST() {
    return process.env.EPOCH_MSAPI_HOST || process.env.NEXT_EPOCH_HOST;
  },
  get EPOCH_MSAPI_OFFERS_PATH() {
    return process.env.EPOCH_MSAPI_OFFERS_PATH || '/msapi/epochofferms/v2/getOffers';
  },
  // ---------------------------------------------------------------------------
  // DCP Mule Epoch offers (WAT-11463)
  // Epoch moved off IDP onto the DCP Mule internal Experience API
  // (`dtvepoch-offerms-int-xapi`) — see EPOCH OfferMS AID §8. Mirrors the
  // sales-ui rollout: BOTH offer routes switch together behind
  // NEXT_DCP_EPOCH_ENABLED, with the IDP path kept as the off-state so the
  // release has a runtime rollback. Values come from the gitops ConfigMap per
  // tier (WAT-10954 removed env-config.json / the k8s cfgmap templates).
  // ---------------------------------------------------------------------------
  /** When true, both Epoch offer routes call the DCP Mule internal API. */
  get IS_DCP_EPOCH_ENABLED() {
    return process.env.NEXT_DCP_EPOCH_ENABLED?.trim()?.toLowerCase() === "true";
  },
  // ---------------------------------------------------------------------------
  // WAT-11842: agent-tool v2 rollout. The customer-facing URL
  // /tools/agent-package-compare-tool/ never changes, so the v1<->v2 switch is
  // made server-side at story resolution instead of by an Akamai rewrite. The
  // off-state keeps the v1 story AND the v1 component -- today's production
  // behaviour -- so flipping this back is the runtime rollback and needs no
  // edge change. Values come from the gitops ConfigMap per tier.
  // ---------------------------------------------------------------------------
  /** When true, the agent-tool base slug resolves the `-v2` Storyblok story. */
  get IS_AGENT_TOOL_V2_ENABLED() {
    return process.env.ENABLE_AGENT_TOOL_V2?.trim()?.toLowerCase() === "true";
  },
  /** Mule gateway origin for this tier, e.g. the internal API host. */
  get DCP_EPOCH_HOST() {
    return process.env.NEXT_DCP_EPOCH_HOST;
  },
  /** Mule `{env}` route segment naming the Epoch backend instance. */
  get DCP_EPOCH_ENV() {
    return process.env.NEXT_DCP_EPOCH_ENV;
  },
  /**
   * FULL `Authorization` header value for the DCP Mule API. The AID documents
   * Basic auth, so the value carries its own `Basic ` prefix — same convention
   * as EPOCH_ACCESS_TOKEN and CHANNELS_SERVICE_AUTH_TOKEN. Supplied by the
   * ArgoCD PreSync k8s Secret in deployed envs, `.env.<profile>` locally.
   */
  get DCP_EPOCH_AUTH() {
    return process.env.NEXT_EPOCH_AUTH;
  },
  // ---------------------------------------------------------------------------
  // Epoch SwimLaneSwitch — SLS (WAT-11983 + WAT-11842), Epoch go-live 2026-09-16
  // Under SLS `contractIndicator` collapses to "RR" for residential flows and
  // the cohort selector moves to a new `customerSubscriptionType` request field.
  // Per tier, and read at call time so no REBUILD is needed: a tier's Epoch
  // migration state is only inferable from the response (an un-migrated backend
  // answers the SLS-shaped genre request with the streaming catalogue at HTTP
  // 200, no error), so each tier has to be able to flip on its own schedule.
  //
  // What a flip actually costs — env vars injected from a ConfigMap are fixed at
  // container start, so it is a ConfigMap edit PLUS a pod rollout, and it reaches
  // Epoch on the next offer-cache refresh rather than the next user request
  // (both lanes sit behind lib/cache/resolver/epoch-*-offers.resolver.ts). It is
  // NOT the no-restart behaviour of the rollout-config asset. Absent means OFF.
  // ---------------------------------------------------------------------------
  /**
   * When true, the genre and DTVI streaming offer payloads use the post-SLS
   * cohort contract, AND both integration-partner calls — the direct agent-tool
   * one (getIntegrationPartnerOffersConfig) and the indirect dealer one
   * (getIndirectPartnerOffersConfig, dealerCode/dealerId supplied per request) —
   * send contractIndicator ["RR"] instead of ["RR", "GENRE"]. Every other Epoch
   * payload builder is unaffected by THIS flag — pinned by the exhaustive
   * carrier and indicator sweeps in epochConfig.spec.ts rather than by a count
   * here, so a 16th builder cannot quietly falsify the claim.
   *
   * The partner half arrived here on 2026-09-11 (WAT-11842), folded in from a
   * retired second flag, NEXT_ENABLE_UNIVERSAL_COHORT, that encoded the same
   * per-tier fact. Two switches for one fact had already left stage
   * half-migrated. Default OFF either way, because the combined indicator is
   * correct against BOTH a migrated and an un-migrated Epoch, so a tier nobody
   * flips keeps working. Flipping moves genre prices in BOTH directions — the
   * measured hazards are on getIntegrationPartnerContractIndicator() in
   * lib/service/epoch/epochConfig.ts, and that is the doc to read before a tier
   * flip. The RESPONSE PARSING needs no flag: the resolver detects the catalog
   * shape per offer and reads this only to decide whether a genre-source-less
   * response is worth an ERROR, never to change what it returns.
   *
   * "Unaffected by THIS flag" is narrower than "unaffected by SLS": the two
   * SVOD builders take contractIndicator from a per-tier ConfigMap override, so
   * a tier could still be sending the retired "GENRE" value without it
   * appearing in any code search. See the scope note above
   * getGenreOffersConfig and WAT-11999 AC #5.
   */
  get IS_EPOCH_SLS_ENABLED() {
    return process.env.NEXT_EPOCH_SLS_ENABLED?.trim()?.toLowerCase() === "true";
  },
  get START_UP_JITTER_MAX_MN() {
    return process.env.START_UP_JITTER_MAX_MN ? parseInt(process.env.START_UP_JITTER_MAX_MN) : 1; // 1 minute
  },

  // ---------------------------------------------------------------------------
  // channels-service integration (WAT-10500 / Phase 1)
  // See target/UF_INTEGRATION_PLAN.md §2.3
  // ---------------------------------------------------------------------------
  /** Mule proxy host for the channels-service (full origin + base path). */
  get MULE_HOST() {
    return process.env.MULE_HOST;
  },
  /**
   * Optional full `Authorization` header value used when calling the
   * channels-service via the Mule edge (the VPM Mule edge proxy).
   * When unset, no Authorization header is sent (suitable for in-cluster calls
   * routed via the conexus proxy, OR direct calls to the channels-service
   * cluster ingress where no auth is required).
   *
   * Convention mirrors EPOCH_ACCESS_TOKEN: the value is the FULL header
   * value, including any `Basic ` / `Bearer ` prefix. Loaded from AWS
   * Secrets Manager via `server/aws/load-secrets.ts` in deployed envs;
   * placed in `.env` for local dev.
   */
  get CHANNELS_SERVICE_AUTH_TOKEN() {
    return process.env.CHANNELS_SERVICE_AUTH_TOKEN;
  },
  /**
   * Per-env flag for the channels-service migration. Sourced from the
   * gitops ConfigMap `<env>.configMapData.USE_CHANNELS_SERVICE` (TRUE/FALSE
   * string, matching the existing USE_STORYBLOK / USE_AEM / USE_EVOLV
   * convention). When TRUE:
   *   - channels[] come from the channels-service (replaces flat-file channels)
   *   - chrome / CCT config come from Storyblok stories
   *     (sales/www/channel-lineup/index + sales/www/channel-lineup/modal)
   *     instead of AEM flat-files (chlupPageData.json + chlupCmprModalData.json)
   * When FALSE: existing CMS-fetched path serves channel data exactly as
   * it does today during rollout.
   */
  get USE_CHANNELS_SERVICE() {
    return process.env.USE_CHANNELS_SERVICE;
  },
  /**
   * WAT-11611: when TRUE the channels-service `locals` half of the response is
   * adapted and cached under its own key (`channelsService:<platform>:locals`),
   * and /api/local-channels serves one market from it, so local stations come
   * from the service instead of the beam local-channel xapi.
   *
   * SCOPE — flag OFF, that key holds `{}`, the route answers `{enabled:false}`
   * and every consumer stays on today's xapi path, so the render is unchanged.
   * Sits UNDER USE_CHANNELS_SERVICE: with the parent flag off the service is not
   * the channel source at all and this one cannot do anything.
   *
   * Read at populate time (adaptPlatformList), by the route, and per page render
   * by `channelsServiceLocalsAttr` (the <html> attribute both routers stamp). The
   * env var itself changes only on a pod restart; the cached locals then refill on
   * the next cache refresh (UF_CACHE_INT). Read SERVER-SIDE ONLY — the client asks the route instead of reading a prop,
   * because publicRuntimeConfig is Pages-Router-only and breaks under the App Router.
   */
  get ENABLE_CHANNELSERVICE_LOCALS() {
    return process.env.ENABLE_CHANNELSERVICE_LOCALS;
  },
  /**
   * WAT-11362: when TRUE the channels-service adapter emits the OV catalog logo
   * (imageURL) as each channel's logo instead of the legacy logoUrl, falling
   * back to logoUrl when a channel has no OV match.
   *
   * SCOPE — gates the logo SOURCE only. Every presentation change rides on the
   * per-channel `isOvLogo` the adapter set, so with the flag off nothing is styled
   * and the render is byte-identical to production. The ONE exception is
   * `objectFit: "contain"` on the channel-logo styles, applied UNCONDITIONALLY (a
   * no-op for the square legacy logoUrl artwork) and NOT reverted by FALSE; rolling
   * that back needs a code revert. Read at populate time (adaptChannel), so a flip
   * takes effect on the next cache refresh (UF_CACHE_INT) / pod restart, not
   * immediately.
   *
   * AUTHORITY — `config/env-config.json` `default.configMap` (inherited by every
   * env). `server/aws/load-secrets.ts` mounts that over `process.env` at startup,
   * so it OVERWRITES any k8s/GitOps ConfigMap value. Opting an env out means
   * adding `"USE_OV_CHANNEL_LOGO": "FALSE"` to that env's configMap block and
   * redeploying — a ConfigMap-only flip will not take effect. (The k8s/cfgmap*
   * entries are kept for parity with USE_CHANNELS_SERVICE.)
   */
  get USE_OV_CHANNEL_LOGO() {
    return process.env.USE_OV_CHANNEL_LOGO;
  },
  /**
   * Backend environment for the channels-service `dcp-env` routing header.
   * Decoupled from K8S_ENV_PREFIX because the channels-service backend is only
   * deployed to specific VPM envs — all non-prod points at `test1` (the single
   * deployed backend), stage → `stage2`, prod → `prod1`. Sourced per-env from
   * the gitops ConfigMap `<env>.configMapData.CHANNELS_SERVICE_ENV`. When
   * unset, no `dcp-env` header is sent.
   */
  get CHANNELS_SERVICE_ENV() {
    return process.env.CHANNELS_SERVICE_ENV;
  },

  // ---------------------------------------------------------------------------
  // dtvcomms sendEmail integration (agent-tool "Email quote")
  // Calls the dtvcomms VPM host DIRECTLY — not the Mule edge, and not sharing
  // MULE_HOST / the `dcp-env` routing header with channels-service. The edge
  // rejected our credential on this path and had no dtvcomms backend behind
  // `dcp-env: test2`; the VPM host answered from a UF test2 pod on 2026-08-18.
  // Same host the video-sales apps use for this API.
  // ---------------------------------------------------------------------------
  /**
   * Origin of the dtvcomms VPM host, e.g. the tier VPM address. Per-env: the
   * host differs per tier. The route returns 503 when unset.
   */
  get VPM_HOST() {
    return process.env.VPM_HOST;
  },

  /**
   * Authorization header value for the dtvcomms sendEmail call, verbatim
   * (the scheme is part of the stored value). Held in the env secret bundle.
   */
  get COMMS_EMAIL_TOKEN() {
    return process.env.COMMS_EMAIL_TOKEN;
  },

  /**
   * `x-source-system` sent to dtvcomms. Per-env so it can be pointed at a value
   * already on that build's `allowedSourceSystems` list without a deploy.
   * Defaults to DTVUF in code when unset.
   */
  get DTVCOMMS_SOURCE_SYSTEM() {
    return process.env.DTVCOMMS_SOURCE_SYSTEM;
  },

  /**
   * Salesforce template id used for the agent-tool quote-summary email. Sent as
   * `sfTemplateId` in the dtvcomms sendEmail payload. Per-env so Salesforce can
   * rotate the template without a code change; the route returns 503 when unset.
   */
  get DTVCOMMS_QUOTE_TEMPLATE_ID() {
    return process.env.DTVCOMMS_QUOTE_TEMPLATE_ID;
  }
};

export default envConstants;
